// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import * as OnboardingInfo from './OnboardingInfo';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { ReliefAttemptsInput, OnboardingInfoSignupIntent, Borough, LeaseType } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: ReliefAttemptsMutation
// ====================================================

export interface ReliefAttemptsMutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface ReliefAttemptsMutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: ReliefAttemptsMutation_output_errors_extendedMessages[];
}

export interface ReliefAttemptsMutation_output_session_onboardingInfo {
  /**
   * The reason the user originally signed up with us.
   */
  signupIntent: OnboardingInfoSignupIntent;
  /**
   * The user's address. Only street name and number are required.
   */
  address: string;
  /**
   * The non-NYC city the user's address is in, if they live outside of NYC.
   */
  nonNycCity: string;
  /**
   * The user's ZIP code. This field is automatically updated for NYC users when you change the address or borough.
   */
  zipcode: string;
  /**
   * The user's Boro, Block, and Lot number. This field is automatically updated
   * for NYC users when you change the address or borough.
   */
  padBbl: string;
  aptNumber: string;
  /**
   * The floor number the user's apartment is on.
   */
  floorNumber: number | null;
  /**
   * Has the user called 311 before?
   */
  hasCalled311: boolean | null;
  /**
   * Does the user receive public assistance, e.g. Section 8?
   */
  receivesPublicAssistance: boolean | null;
  /**
   * Whether the user has agreed to the JustFix.nyc terms of service and privacy policy.
   */
  agreedToJustfixTerms: boolean;
  /**
   * Whether the user has agreed to the NoRent.org terms of service and privacy policy.
   */
  agreedToNorentTerms: boolean;
  /**
   * Whether the user has agreed to the Eviction Free terms of service and privacy policy.
   */
  agreedToEvictionfreeTerms: boolean;
  /**
   * Whether the user has agreed to the LA Letter Builder terms of service and privacy policy.
   */
  agreedToLaletterbuilderTerms: boolean;
  /**
   * Whether the user has opted-in to being contacted by the Right to the City Alliance (RTTC).
   */
  canReceiveRttcComms: boolean | null;
  /**
   * Whether the user has opted-in to being contacted by Strategic Actions for a Just Economy (SAJE).
   */
  canReceiveSajeComms: boolean | null;
  /**
   * The New York City borough the user's address is in, if they live inside NYC.
   */
  borough: Borough | null;
  /**
   * The type of housing the user lives in (NYC only).
   */
  leaseType: LeaseType | null;
  /**
   * The two-letter state or territory of the user, e.g. "NY".
   */
  state: string;
  /**
   * The city of the user. For NYC-based users, this will be the same as
   *         the borough name, except we use "New York" instead of "Manhattan".
   */
  city: string;
  /**
   * Whether the user is in Los Angeles County. If we don't have enough information to tell, this will be null.
   */
  isInLosAngeles: boolean | null;
  /**
   * The user's full mailing address, as it will appear on mailings and other official documents.
   */
  fullMailingAddress: string;
  /**
   * The county of the user's address, or null if we don't know.
   */
  county: string | null;
}

export interface ReliefAttemptsMutation_output_session {
  /**
   * The user's onboarding details, which they filled out during the onboarding
   * process. This is not to be confused with the individual onboarding steps,
   * which capture information someone filled out *during* onboarding, before they
   * became a full-fledged user.
   */
  onboardingInfo: ReliefAttemptsMutation_output_session_onboardingInfo | null;
}

export interface ReliefAttemptsMutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: ReliefAttemptsMutation_output_errors[];
  session: ReliefAttemptsMutation_output_session | null;
}

export interface ReliefAttemptsMutation {
  output: ReliefAttemptsMutation_output;
}

export interface ReliefAttemptsMutationVariables {
  input: ReliefAttemptsInput;
}

export const BlankReliefAttemptsInput: ReliefAttemptsInput = {
  "hasCalled311": ""
};

export const ReliefAttemptsMutation = {
  // The following query was taken from ReliefAttemptsMutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation ReliefAttemptsMutation($input: ReliefAttemptsInput!) {
  output: reliefAttempts(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      onboardingInfo { ...OnboardingInfo }
    }
  }
}
${ExtendedFormFieldErrors.graphQL}
${OnboardingInfo.graphQL}`,
  name: "ReliefAttemptsMutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: ReliefAttemptsMutationVariables): Promise<ReliefAttemptsMutation> {
    return fetchGraphQL(ReliefAttemptsMutation.graphQL, args);
  },
  blankInput: BlankReliefAttemptsInput,
};

export const fetchReliefAttemptsMutation = ReliefAttemptsMutation.fetch;